
import { mapActions, mapState, mapGetters } from "vuex";
import orderListHeader from "./order-list-header.vue";
import OrderListRow from "./order-list-row.vue";
import PairPlatforms from "~/assets/images/pairPlatforms.svg";
import integrationUnderProcessing from "../reciever/integration-under-processing.vue";
import welcomeUserScreen from "../common/welcome-user-screen.vue";

export default {
  components: {
    orderListHeader,
    OrderListRow,
    integrationUnderProcessing,
    welcomeUserScreen
  },
  props: {
    hasChannelsPaired: {
      type: Boolean,
      default: false
    },
    channelsPairedAndEmptyMenubook: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.sections = this.$constants.OrderStatuses.SECTIONS;
  },
  data() {
    return {
      PairPlatforms,
      headers: [
        {
          value: "billNo",
          label: "Bill No.",
          width: "10%",
          tabWidth: "10%"
        },
        {
          value: "tokenNo",
          label: "Token No.",
          labelIfBrands: "Brand & Token",
          width: "10%",
          tabWidth: "10%"
        },
        {
          value: "channelAndOrderId",
          label: "Channel & Order ID",
          width: "20%",
          tabWidth: "20%"
        },
        {
          value: "deliveryPerson",
          label: "Delivery / Pickup Person",
          width: "25%",
          tabWidth: "25%"
        },
        {
          value: "duration",
          label: "Time Left",
          width: "10%",
          tabWidth: "10%"
        },
        {
          value: "amount",
          label: "Amount",
          width: "10%",
          tabWidth: "10%"
        },
        {
          value: "action",
          label: "Action",
          width: "15%",
          tabWidth: "15%"
        }
      ],
      sections: [],
      selectedHeader: {},
      selectedOrder: {},
      sortOrder: "asc"
    };
  },
  computed: {
    ...mapState("reciever", ["orders"]),
    ...mapGetters("reciever", [
      "getSelectedChannelAllOrders",
      "getSelectedChannelNewOrders",
      "getSelectedChannelPreparingOrders",
      "getSelectedChannelReadyForDeliveryOrders",
      "getSelectedChannelPickedUpOrders"
    ]),
    ...mapState("restaurant", ["printers", "locationDetails"]),
    ...mapGetters("restaurant", ["getRecieverSettings", "activeChannelCount"])
  },

  created() {
    this.$nuxt.$on("switch-restaurant", this.clearRecieverData);
    this.selectedHeader = this.headers[0];
  },
  methods: {
    ...mapActions("reciever", ["clearRecieverData", "getOrderDetailsObj"]),
    showSection(section) {
      if (section.status === "newOrders") {
        return (
          this.getSelectedChannelNewOrders?.length ||
          this.locationDetails.restaurants.some(
            (restaurant) => !restaurant.settings?.enable_auto_accept
          )
        );
      }
      return true;
    },

    headerSelectionChanged(selectedHeader) {
      if (this.selectedHeader.value === selectedHeader.value) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.selectedHeader = selectedHeader;
        this.sortOrder = "asc";
      }
    },

    getList(status) {
      if (status === "newOrders") {
        return this.getSelectedChannelNewOrders;
      } else if (status === "preparing") {
        return this.getSelectedChannelPreparingOrders;
      } else if (status === "readyForDelivery") {
        return this.getSelectedChannelReadyForDeliveryOrders;
      } else if (status === "pickedUp") {
        return this.getSelectedChannelPickedUpOrders;
      } else {
        return [];
      }
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("switch-restaurant");
  }
};
